import { addBusinessDays, addDays, isAfter, isBefore, startOfDay } from "date-fns";
import { deduplicateDatesByCalendarDay } from "@utils/dateFormat";

export const NO_INSTALL_ACTIVATION_DELAY_DAYS = 3;

export const NO_INSTALL_ACTIVATION_PICKER_MAX_DAYS = 30;

export const computeFilteredNoInstallActivationDates = (
    activationDatesList: Date[],
    referenceNow: Date = new Date()
): Date[] => {
    const today = startOfDay(referenceNow);
    const delayDate = addDays(today, NO_INSTALL_ACTIVATION_DELAY_DAYS);
    const maxDate = addDays(today, NO_INSTALL_ACTIVATION_PICKER_MAX_DAYS);

    const activationDateListSorted = [...activationDatesList]
        .map((date) => startOfDay(date))
        .filter((date) => !isBefore(date, delayDate) && !isAfter(date, maxDate))
        .sort((a, b) => a.getTime() - b.getTime());

    return deduplicateDatesByCalendarDay(activationDateListSorted);
};

export const computeFirstNoInstallActivationDate = (
    filteredActivationDateList: Date[],
    referenceNow: Date = new Date()
): Date => filteredActivationDateList[0] ?? addBusinessDays(startOfDay(referenceNow), NO_INSTALL_ACTIVATION_DELAY_DAYS);
